import Spinner from "../../ui/spinner/Spinner";
import styles from "../ContentItem.module.scss";
import ExternalLinkTarget from "../components/externalLinkTarget/ExternalLinkTarget";
import Image from "../components/image/Image";
import CategoryAssetItem from "./CategoryAssetItem";
import { CategoryType } from "./OnPage";
import { ApprovePayload } from "./types";

interface AssetDetail {
  id?: number;
  suggestion?: string;
  original?: string;
  content?: string;
  approved?: boolean;
  active?: boolean;
  final?: string;
}

interface AssetItem {
  id: number;
  path_and_query: string;
  title?: string;
  path?: string;
  src?: string;
  suggestion?: string;
  active?: boolean;
  appearances: number; // Make this required with a default value
  final?: string;
  details?: AssetDetail[];
  lang: string | null;
}

interface PendingStatus {
  id: number;
  status: string;
  widget_recommendation_id: number;
  variant: string;
  approved: boolean;
}

interface CategoryAssetItemsProps {
  data: AssetItem[];
  currentCategory?: CategoryType;
  approve: (data: ApprovePayload) => void;
  editPageSuggestion: (data: { id: number; final: string }) => void;
  pendingStatuses?: PendingStatus[];
  isLoading?: boolean;
  isFetchingAssetSuggestions?: boolean;
  isWidgetActionLoading?: boolean;
}

const CategoryAssetItems = ({
  data,
  approve,
  currentCategory,
  pendingStatuses = [],
  isLoading = false,
  isFetchingAssetSuggestions = false,
  editPageSuggestion,
  isWidgetActionLoading = false,
}: CategoryAssetItemsProps) => {
  if (isFetchingAssetSuggestions && !data?.length) {
    return (
      <div className={styles.currentItemSpinner}>
        <Spinner />
      </div>
    );
  }

  if (currentCategory?.slug === "images-have-alt-title") {
    return (
      <Image
        data={data.map((item) => ({ ...item, src: item.src ?? "" }))}
        approve={(data) => approve({ ...data, ids: data.ids ?? [] })}
        isLoading={isLoading}
        editPageSuggestion={editPageSuggestion}
        isWidgetActionLoading={isWidgetActionLoading}
      />
    );
  }

  if (currentCategory?.slug === "external-link-target") {
    return (
      <ExternalLinkTarget
        data={data}
        approve={(data) => approve({ ...data, ids: data.ids ?? [] })}
        isLoading={isLoading}
        //@ts-expect-error by type fix once done
        editPageSuggestion={editPageSuggestion}
        isWidgetActionLoading={isWidgetActionLoading}
      />
    );
  }

  return (
    <div className={styles.currentItemGroup}>
      {data?.map((item, index) => {
        const hasPendingStatus = pendingStatuses.some(
          (status) => status.widget_recommendation_id === item.id,
        );

        return (
          <CategoryAssetItem
            key={item.id}
            approve={approve}
            item={{ ...item, appearances: item.appearances ?? 0 }}
            isDefaultOpen={index === 0}
            currentCategory={currentCategory!}
            isLoading={
              isLoading || isFetchingAssetSuggestions || hasPendingStatus
            }
            isDisabled={!!hasPendingStatus || !!isLoading}
            hasPendingStatus={hasPendingStatus}
            editPageSuggestion={editPageSuggestion}
            isWidgetActionLoading={isWidgetActionLoading}
          />
        );
      })}
    </div>
  );
};

export default CategoryAssetItems;
